import type { FC } from 'react'
import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import { Customer } from '@pylot-data/fwrdschema'

type Props = {
    customer: Customer
}

export const InformationCard: FC<Props> = ({ customer }) => {
    const { t } = useTranslation(['account'])
    const { firstname = '', lastname = '', email = '', date_of_birth = '' } =
        customer || {}

    return (
        <div className="account-details box-info">
            <h2 className="box-info-title">
                {t('account|Contact Information')}
            </h2>
            <div className="box-details">
                <span>{`${firstname} ${lastname}`}</span>
                <span>{email}</span>
                {!!date_of_birth && (
                    <span>{`${t(
                        'account|Date of Birth: '
                    )}${date_of_birth}`}</span>
                )}
            </div>
            <div className="action-container">
                <Link href="/account/account-information">
                    {t('account|Edit')}
                </Link>
                <Link
                    href={{
                        pathname: '/account/account-information',
                        query: { action: 'password' }
                    }}
                >
                    {t('account|Change Password')}
                </Link>
            </div>
        </div>
    )
}
